import { useEffect, useState, useRef } from 'react';
import * as XLSX from 'xlsx';

const BACKEND = 'https://3amenu.com/api';
const SITE_URL = 'https://3amenu.com';

const sesCardir = (tip) => {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain);
  gain.connect(ctx.destination);
  if (tip === 'siparis') {
    osc.frequency.setValueAtTime(440, ctx.currentTime);
    osc.frequency.setValueAtTime(550, ctx.currentTime + 0.1);
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
    osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.3);
  } else if (tip === 'garson' || tip === 'aksiyon') {
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.setValueAtTime(660, ctx.currentTime + 0.15);
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
    osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.4);
  } else if (tip === 'hesap') {
    osc.frequency.setValueAtTime(523, ctx.currentTime);
    osc.frequency.setValueAtTime(659, ctx.currentTime + 0.15);
    osc.frequency.setValueAtTime(784, ctx.currentTime + 0.3);
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
    osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.5);
  }
};

const adisyonYazdir = (masa, kafeAdi, termal = false) => {
  const tarih = new Date().toLocaleString('tr-TR');
  const satirlar = masa.siparisler.flatMap(s => s.urunler);
  const birlestir = [];
  satirlar.forEach(u => {
    const mevcut = birlestir.find(x => x.ad === u.ad);
    if (mevcut) { mevcut.adet += u.adet; mevcut.toplam += u.fiyat * u.adet; }
    else birlestir.push({ ad: u.ad, fiyat: u.fiyat, adet: u.adet, toplam: u.fiyat * u.adet });
  });
  const genislik = termal ? '80mm' : '210mm';
  const fontSize = termal ? '12px' : '14px';
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Adisyon - Masa ${masa.masaNo}</title>
    <style>* { margin: 0; padding: 0; box-sizing: border-box; } body { font-family: 'Courier New', monospace; font-size: ${fontSize}; width: ${genislik}; padding: 10px; }
    .header { text-align: center; border-bottom: 1px dashed #000; padding-bottom: 8px; margin-bottom: 8px; }
    .header h2 { font-size: ${termal ? '14px' : '18px'}; font-weight: bold; } .header p { font-size: ${termal ? '10px' : '12px'}; }
    .urun-satir { display: flex; justify-content: space-between; padding: 3px 0; border-bottom: 1px dotted #ccc; }
    .urun-ad { flex: 1; } .urun-adet { width: 30px; text-align: center; } .urun-fiyat { width: 60px; text-align: right; }
    .toplam { display: flex; justify-content: space-between; font-weight: bold; font-size: ${termal ? '13px' : '16px'}; margin-top: 10px; padding-top: 8px; border-top: 2px solid #000; }
    .footer { text-align: center; margin-top: 12px; font-size: ${termal ? '10px' : '11px'}; color: #666; }
    @media print { body { margin: 0; } }</style></head><body>
    <div class="header"><h2>${kafeAdi || 'Kafe'}</h2><p>Masa ${masa.masaNo}</p><p>${tarih}</p></div>
    <div style="margin-bottom: 8px;">
      <div class="urun-satir" style="font-weight: bold; border-bottom: 1px solid #000;"><span class="urun-ad">Ürün</span><span class="urun-adet">Adet</span><span class="urun-fiyat">Tutar</span></div>
      ${birlestir.map(u => `<div class="urun-satir"><span class="urun-ad">${u.ad}</span><span class="urun-adet">${u.adet}</span><span class="urun-fiyat">₺${u.toplam}</span></div>`).join('')}
    </div>
    <div class="toplam"><span>TOPLAM</span><span>₺${masa.toplam}</span></div>
    <div class="footer"><p>Teşekkür ederiz!</p><p>3AMenu ile hazırlandı</p></div>
    </body></html>`;
  const win = window.open('', '_blank', termal ? 'width=350,height=600' : 'width=800,height=600');
  win.document.write(html); win.document.close(); win.focus();
  setTimeout(() => { win.print(); }, 500);
};

// ─────────────────────────────────────────────
// RAPORLAR sekmesi
// ─────────────────────────────────────────────
function RaporlarSekmesi({ cafeId }) {
  const bugun = new Date().toISOString().split('T')[0];
  const [baslangic, setBaslangic] = useState(bugun);
  const [bitis, setBitis] = useState(bugun);
  const [rapor, setRapor] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [aktifTab, setAktifTab] = useState('siparis');
  const [duzenleModal, setDuzenleModal] = useState(null);
  const [duzenleUrunler, setDuzenleUrunler] = useState([]);

  const hizliTarih = (tip) => {
    const bugunDate = new Date();
    if (tip === 'bugun') {
      setBaslangic(bugun); setBitis(bugun);
    } else if (tip === 'dun') {
      const dun = new Date(bugunDate); dun.setDate(dun.getDate() - 1);
      const dunStr = dun.toISOString().split('T')[0];
      setBaslangic(dunStr); setBitis(dunStr);
    } else if (tip === 'hafta') {
      const haftaBasi = new Date(bugunDate); haftaBasi.setDate(haftaBasi.getDate() - 6);
      setBaslangic(haftaBasi.toISOString().split('T')[0]); setBitis(bugun);
    } else if (tip === 'ay') {
      const ayBasi = new Date(bugunDate.getFullYear(), bugunDate.getMonth(), 1);
      setBaslangic(ayBasi.toISOString().split('T')[0]); setBitis(bugun);
    }
  };

  const raporGetir = async () => {
    setYukleniyor(true);
    try {
      const res = await fetch(`${BACKEND}/siparisler/rapor-detay/${cafeId}?baslangic=${baslangic}&bitis=${bitis}`).then(r => r.json());
      setRapor(res);
    } catch { alert('Rapor alınamadı!'); }
    setYukleniyor(false);
  };

  useEffect(() => { raporGetir(); }, []);

  const excelIndir = () => {
    if (!rapor) return;
    const wb = XLSX.utils.book_new();
    const siparisData = [
      ['Tarih', 'Saat', 'Masa', 'Ürünler', 'Toplam (₺)'],
      ...rapor.satirlar.map(s => [s.tarih, s.saat, `Masa ${s.masaNo}`, s.urunler.map(u => `${u.ad} x${u.adet}`).join(', '), s.toplam]),
      [], ['', '', '', 'GENEL TOPLAM', rapor.genelToplam],
    ];
    const ws1 = XLSX.utils.aoa_to_sheet(siparisData);
    ws1['!cols'] = [{ wch: 12 }, { wch: 8 }, { wch: 8 }, { wch: 50 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, ws1, 'Siparişler');
    const urunData = [['Ürün Adı', 'Satış Adedi', 'Toplam Ciro (₺)'], ...rapor.urunListesi.map(u => [u.ad, u.adet, u.toplam])];
    const ws2 = XLSX.utils.aoa_to_sheet(urunData);
    ws2['!cols'] = [{ wch: 30 }, { wch: 12 }, { wch: 16 }];
    XLSX.utils.book_append_sheet(wb, ws2, 'Ürün Bazlı');
    const masaData = [['Masa No', 'Sipariş Sayısı', 'Toplam Ciro (₺)'], ...rapor.masaListesi.map(m => [`Masa ${m.masaNo}`, m.siparisSayisi, m.toplam])];
    const ws3 = XLSX.utils.aoa_to_sheet(masaData);
    ws3['!cols'] = [{ wch: 10 }, { wch: 14 }, { wch: 16 }];
    XLSX.utils.book_append_sheet(wb, ws3, 'Masa Bazlı');
    XLSX.writeFile(wb, `3amenu-rapor-${baslangic}-${bitis}.xlsx`);
  };

  const siparisiSil = async (id) => {
    if (!window.confirm('Bu siparişi silmek istediğinize emin misiniz?')) return;
    try {
      await fetch(`${BACKEND}/siparisler/${id}`, { method: 'DELETE' });
      raporGetir();
    } catch { alert('Hata!'); }
  };

  const duzenleAc = (satir) => { setDuzenleUrunler(satir.urunler.map(u => ({ ...u }))); setDuzenleModal(satir); };

  const duzenleKaydet = async () => {
    try {
      await fetch(`${BACKEND}/siparisler/${duzenleModal.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ urunler: duzenleUrunler }),
      });
      setDuzenleModal(null); raporGetir();
    } catch { alert('Hata!'); }
  };

  return (
    <div>
      {/* Filtre */}
      <div className="bg-white rounded-xl p-4 mb-4">
        <div className="flex gap-2 mb-3 flex-wrap">
          {[{ key: 'bugun', label: 'Bugün' }, { key: 'dun', label: 'Dün' }, { key: 'hafta', label: 'Son 7 Gün' }, { key: 'ay', label: 'Bu Ay' }].map(({ key, label }) => (
            <button key={key} onClick={() => hizliTarih(key)} className="px-3 py-1.5 rounded-xl text-sm font-medium bg-orange-50 text-orange-600 hover:bg-orange-100">{label}</button>
          ))}
        </div>
        <div className="flex gap-2 items-end">
          <div className="flex-1">
            <label className="text-xs text-gray-500 mb-1 block">Başlangıç</label>
            <input type="date" value={baslangic} onChange={e => setBaslangic(e.target.value)} className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-orange-400" />
          </div>
          <div className="flex-1">
            <label className="text-xs text-gray-500 mb-1 block">Bitiş</label>
            <input type="date" value={bitis} onChange={e => setBitis(e.target.value)} className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:border-orange-400" />
          </div>
          <button onClick={raporGetir} disabled={yukleniyor} className="bg-orange-500 text-white px-4 py-2 rounded-xl font-medium hover:bg-orange-600 disabled:opacity-50">
            {yukleniyor ? '⏳' : '🔍 Getir'}
          </button>
        </div>
      </div>

      {rapor && (
        <>
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="bg-orange-500 text-white rounded-xl p-4 text-center">
              <p className="text-2xl font-bold">₺{rapor.genelToplam.toLocaleString('tr-TR')}</p>
              <p className="text-sm opacity-80 mt-1">Toplam Ciro</p>
            </div>
            <div className="bg-gray-800 text-white rounded-xl p-4 text-center">
              <p className="text-2xl font-bold">{rapor.toplamSiparis}</p>
              <p className="text-sm opacity-80 mt-1">Sipariş Sayısı</p>
            </div>
          </div>

          <button onClick={excelIndir} className="w-full bg-green-500 text-white py-3 rounded-xl font-semibold hover:bg-green-600 mb-4 flex items-center justify-center gap-2">
            📥 Excel İndir (.xlsx)
          </button>

          <div className="flex gap-2 mb-3">
            {[{ key: 'siparis', label: '📋 Siparişler' }, { key: 'urun', label: '🍽️ Ürün Bazlı' }, { key: 'masa', label: '🪑 Masa Bazlı' }].map(({ key, label }) => (
              <button key={key} onClick={() => setAktifTab(key)}
                className={`flex-1 py-2 rounded-xl text-sm font-medium ${aktifTab === key ? 'bg-orange-500 text-white' : 'bg-white text-gray-600'}`}>{label}</button>
            ))}
          </div>

          {aktifTab === 'siparis' && (
            <div className="bg-white rounded-xl overflow-hidden">
              {rapor.satirlar.length === 0 ? (
                <div className="p-8 text-center text-gray-400">Bu tarih aralığında sipariş yok</div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50 border-b border-gray-100">
                      <tr>
                        <th className="text-left px-4 py-3 text-gray-600 font-semibold">Tarih/Saat</th>
                        <th className="text-left px-4 py-3 text-gray-600 font-semibold">Masa</th>
                        <th className="text-left px-4 py-3 text-gray-600 font-semibold">Ürünler</th>
                        <th className="text-right px-4 py-3 text-gray-600 font-semibold">Toplam</th>
                        <th className="text-center px-4 py-3 text-gray-600 font-semibold">İşlem</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rapor.satirlar.map((satir, i) => (
                        <tr key={satir.id} className={`border-b border-gray-50 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                          <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                            <div>{satir.tarih}</div><div className="text-xs text-gray-400">{satir.saat}</div>
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-800">Masa {satir.masaNo}</td>
                          <td className="px-4 py-3 text-gray-600">
                            <div className="flex flex-wrap gap-1">
                              {satir.urunler.map((u, j) => (
                                <span key={j} className="bg-gray-100 text-gray-700 px-2 py-0.5 rounded-lg text-xs">{u.ad} x{u.adet}</span>
                              ))}
                            </div>
                          </td>
                          <td className="px-4 py-3 text-right font-bold text-orange-500 whitespace-nowrap">₺{satir.toplam}</td>
                          <td className="px-4 py-3">
                            <div className="flex gap-1 justify-center">
                              <button onClick={() => duzenleAc(satir)} className="bg-blue-100 text-blue-600 px-2 py-1 rounded-lg text-xs hover:bg-blue-200">✏️</button>
                              <button onClick={() => siparisiSil(satir.id)} className="bg-red-100 text-red-500 px-2 py-1 rounded-lg text-xs hover:bg-red-200">🗑️</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="bg-orange-50 border-t-2 border-orange-100">
                      <tr>
                        <td colSpan={3} className="px-4 py-3 font-bold text-gray-800">TOPLAM</td>
                        <td className="px-4 py-3 text-right font-bold text-orange-600 text-base">₺{rapor.genelToplam.toLocaleString('tr-TR')}</td>
                        <td />
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          )}

          {aktifTab === 'urun' && (
            <div className="bg-white rounded-xl overflow-hidden">
              {rapor.urunListesi.length === 0 ? <div className="p-8 text-center text-gray-400">Veri yok</div> : (
                <table className="w-full text-sm">
                  <thead className="bg-gray-50 border-b border-gray-100">
                    <tr>
                      <th className="text-left px-4 py-3 text-gray-600 font-semibold">Ürün</th>
                      <th className="text-right px-4 py-3 text-gray-600 font-semibold">Adet</th>
                      <th className="text-right px-4 py-3 text-gray-600 font-semibold">Ciro</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rapor.urunListesi.map((u, i) => (
                      <tr key={i} className={`border-b border-gray-50 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                        <td className="px-4 py-3 font-medium text-gray-800">{u.ad}</td>
                        <td className="px-4 py-3 text-right text-gray-600">{u.adet}</td>
                        <td className="px-4 py-3 text-right font-bold text-orange-500">₺{u.toplam}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="bg-orange-50 border-t-2 border-orange-100">
                    <tr>
                      <td className="px-4 py-3 font-bold text-gray-800">TOPLAM</td>
                      <td className="px-4 py-3 text-right font-bold text-gray-800">{rapor.urunListesi.reduce((a, u) => a + u.adet, 0)}</td>
                      <td className="px-4 py-3 text-right font-bold text-orange-600">₺{rapor.genelToplam.toLocaleString('tr-TR')}</td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}

          {aktifTab === 'masa' && (
            <div className="bg-white rounded-xl overflow-hidden">
              {rapor.masaListesi.length === 0 ? <div className="p-8 text-center text-gray-400">Veri yok</div> : (
                <table className="w-full text-sm">
                  <thead className="bg-gray-50 border-b border-gray-100">
                    <tr>
                      <th className="text-left px-4 py-3 text-gray-600 font-semibold">Masa</th>
                      <th className="text-right px-4 py-3 text-gray-600 font-semibold">Sipariş</th>
                      <th className="text-right px-4 py-3 text-gray-600 font-semibold">Ciro</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rapor.masaListesi.map((m, i) => (
                      <tr key={i} className={`border-b border-gray-50 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                        <td className="px-4 py-3 font-medium text-gray-800">Masa {m.masaNo}</td>
                        <td className="px-4 py-3 text-right text-gray-600">{m.siparisSayisi}</td>
                        <td className="px-4 py-3 text-right font-bold text-orange-500">₺{m.toplam}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="bg-orange-50 border-t-2 border-orange-100">
                    <tr>
                      <td className="px-4 py-3 font-bold text-gray-800">TOPLAM</td>
                      <td className="px-4 py-3 text-right font-bold text-gray-800">{rapor.toplamSiparis}</td>
                      <td className="px-4 py-3 text-right font-bold text-orange-600">₺{rapor.genelToplam.toLocaleString('tr-TR')}</td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>
          )}
        </>
      )}

      {/* Sipariş düzenleme modal */}
      {duzenleModal && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-end justify-center" onClick={e => { if (e.target === e.currentTarget) setDuzenleModal(null); }}>
          <div className="bg-white rounded-t-3xl w-full max-w-2xl p-6 max-h-[85vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-bold text-gray-800">✏️ Sipariş Düzenle</h2>
              <button onClick={() => setDuzenleModal(null)} className="text-gray-400 text-2xl">✕</button>
            </div>
            <p className="text-sm text-gray-500 mb-4">Masa {duzenleModal.masaNo} — {duzenleModal.tarih} {duzenleModal.saat}</p>
            {duzenleUrunler.map((u, i) => (
              <div key={i} className="flex items-center gap-3 bg-gray-50 rounded-xl p-3 mb-2">
                <div className="flex-1">
                  <p className="font-medium text-gray-800">{u.ad}</p>
                  <p className="text-sm text-gray-500">₺{u.fiyat} / adet</p>
                </div>
                <div className="flex items-center gap-2">
                  <button onClick={() => { const yeni = [...duzenleUrunler]; if (yeni[i].adet > 1) yeni[i] = { ...yeni[i], adet: yeni[i].adet - 1 }; else yeni.splice(i, 1); setDuzenleUrunler(yeni); }}
                    className="bg-gray-200 text-gray-700 w-8 h-8 rounded-full flex items-center justify-center font-bold hover:bg-gray-300">−</button>
                  <span className="font-bold w-6 text-center">{u.adet}</span>
                  <button onClick={() => { const yeni = [...duzenleUrunler]; yeni[i] = { ...yeni[i], adet: yeni[i].adet + 1 }; setDuzenleUrunler(yeni); }}
                    className="bg-orange-100 text-orange-600 w-8 h-8 rounded-full flex items-center justify-center font-bold hover:bg-orange-200">+</button>
                </div>
                <p className="font-bold text-orange-500 w-16 text-right">₺{u.fiyat * u.adet}</p>
              </div>
            ))}
            {duzenleUrunler.length === 0 && <div className="text-center text-gray-400 py-4">Tüm ürünler kaldırıldı</div>}
            <div className="border-t border-gray-100 pt-3 mt-3 flex justify-between items-center mb-4">
              <span className="font-bold text-gray-800">Yeni Toplam</span>
              <span className="font-bold text-orange-500 text-lg">₺{duzenleUrunler.reduce((a, u) => a + u.fiyat * u.adet, 0)}</span>
            </div>
            <div className="flex gap-3">
              <button onClick={() => setDuzenleModal(null)} className="flex-1 bg-gray-100 text-gray-600 py-3 rounded-2xl font-semibold">İptal</button>
              <button onClick={duzenleKaydet} className="flex-1 bg-orange-500 text-white py-3 rounded-2xl font-semibold hover:bg-orange-600">Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// MASA YÖNETİMİ sekmesi (Token sistemi)
// ─────────────────────────────────────────────



// ─────────────────────────────────────────────
// ÖZET sekmesi
// ─────────────────────────────────────────────
function OzetSekmesi({ cafeId }) {
  const [ozet, setOzet] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);

  const ozetGetir = async () => {
    setYukleniyor(true);
    try {
      const res = await fetch(`${BACKEND}/siparisler/ozet/${cafeId}`).then(r => r.json());
      setOzet(res);
    } catch { console.error('Özet alınamadı'); }
    setYukleniyor(false);
  };

  useEffect(() => {
    ozetGetir();
    const interval = setInterval(ozetGetir, 30000); // 30 sn
    return () => clearInterval(interval);
  }, []);

  if (yukleniyor) return (
    <div className="bg-white rounded-xl p-12 text-center text-gray-400">Yükleniyor...</div>
  );
  if (!ozet) return (
    <div className="bg-white rounded-xl p-12 text-center text-gray-400">Veri alınamadı</div>
  );

  const bugun = ozet.bugun;
  const dun = ozet.dun;

  // Dün vs bugün yüzde farkı
  const farkHesapla = (bugunVal, dunVal) => {
    if (dunVal === 0) return bugunVal > 0 ? 100 : 0;
    return Math.round(((bugunVal - dunVal) / dunVal) * 100);
  };
  const ciroFark = farkHesapla(bugun.toplam, dun.toplam);
  const musteriFark = farkHesapla(bugun.musteriSayisi, dun.musteriSayisi);
  const ortalFark = farkHesapla(bugun.ortalama, dun.ortalama);

  // Saatlik grafik max değeri
  const maxSaat = Math.max(...ozet.saatlikCiro, 1);
  const aktifSaatler = ozet.saatlikCiro
    .map((ciro, saat) => ({ saat, ciro }))
    .filter(x => x.ciro > 0);

  return (
    <div>
      {/* Bugün kartları */}
      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="bg-orange-500 text-white rounded-xl p-4 text-center">
          <p className="text-xs opacity-80 mb-1">Bugün Ciro</p>
          <p className="text-2xl font-bold">₺{bugun.toplam.toLocaleString('tr-TR')}</p>
          <p className={`text-xs mt-1 font-medium ${ciroFark >= 0 ? 'opacity-90' : 'opacity-70'}`}>
            {ciroFark >= 0 ? '▲' : '▼'} {Math.abs(ciroFark)}% dünden
          </p>
        </div>
        <div className="bg-gray-800 text-white rounded-xl p-4 text-center">
          <p className="text-xs opacity-80 mb-1">Müşteri</p>
          <p className="text-2xl font-bold">{bugun.musteriSayisi}</p>
          <p className={`text-xs mt-1 font-medium ${musteriFark >= 0 ? 'opacity-90' : 'opacity-70'}`}>
            {musteriFark >= 0 ? '▲' : '▼'} {Math.abs(musteriFark)}% dünden
          </p>
        </div>
        <div className="bg-green-500 text-white rounded-xl p-4 text-center">
          <p className="text-xs opacity-80 mb-1">Ort. Harcama</p>
          <p className="text-2xl font-bold">₺{bugun.ortalama}</p>
          <p className={`text-xs mt-1 font-medium ${ortalFark >= 0 ? 'opacity-90' : 'opacity-70'}`}>
            {ortalFark >= 0 ? '▲' : '▼'} {Math.abs(ortalFark)}% dünden
          </p>
        </div>
      </div>

      {/* Dün vs Bugün karşılaştırma */}
      <div className="bg-white rounded-xl p-4 mb-4">
        <h3 className="font-semibold text-gray-800 mb-3">📅 Dün vs Bugün</h3>
        <div className="grid grid-cols-3 gap-2 text-sm">
          <div className="text-center text-gray-400 font-medium pb-2 border-b border-gray-100"></div>
          <div className="text-center text-gray-500 font-medium pb-2 border-b border-gray-100">Dün</div>
          <div className="text-center text-orange-500 font-medium pb-2 border-b border-gray-100">Bugün</div>

          <div className="text-gray-600 py-2">💰 Ciro</div>
          <div className="text-center text-gray-700 py-2">₺{dun.toplam.toLocaleString('tr-TR')}</div>
          <div className="text-center font-bold text-orange-500 py-2">₺{bugun.toplam.toLocaleString('tr-TR')}</div>

          <div className="text-gray-600 py-2">👥 Müşteri</div>
          <div className="text-center text-gray-700 py-2">{dun.musteriSayisi}</div>
          <div className="text-center font-bold text-orange-500 py-2">{bugun.musteriSayisi}</div>

          <div className="text-gray-600 py-2">📊 Ortalama</div>
          <div className="text-center text-gray-700 py-2">₺{dun.ortalama}</div>
          <div className="text-center font-bold text-orange-500 py-2">₺{bugun.ortalama}</div>
        </div>
      </div>

      {/* Saatlik ciro grafiği */}
      <div className="bg-white rounded-xl p-4 mb-4">
        <h3 className="font-semibold text-gray-800 mb-4">📈 Saatlik Ciro (Bugün)</h3>
        {aktifSaatler.length === 0 ? (
          <p className="text-center text-gray-400 text-sm py-4">Bugün henüz ödeme alınmadı</p>
        ) : (
          <div className="flex items-end gap-1 h-32">
            {ozet.saatlikCiro.map((ciro, saat) => {
              const yukseklik = ciro > 0 ? Math.max((ciro / maxSaat) * 100, 8) : 0;
              return (
                <div key={saat} className="flex-1 flex flex-col items-center gap-1">
                  <div
                    className="w-full rounded-t-sm transition-all"
                    style={{
                      height: `${yukseklik}%`,
                      backgroundColor: ciro > 0 ? '#f97316' : '#f3f4f6',
                      minHeight: ciro > 0 ? '4px' : '0',
                    }}
                    title={`${saat}:00 — ₺${ciro}`}
                  />
                  {saat % 4 === 0 && (
                    <span className="text-xs text-gray-400">{saat}</span>
                  )}
                </div>
              );
            })}
          </div>
        )}
        {aktifSaatler.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-2">
            {aktifSaatler.map(({ saat, ciro }) => (
              <span key={saat} className="text-xs bg-orange-50 text-orange-600 px-2 py-1 rounded-lg">
                {String(saat).padStart(2, '0')}:00 — ₺{ciro}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Açık masalar */}
      <div className="bg-white rounded-xl p-4">
        <h3 className="font-semibold text-gray-800 mb-3">🪑 Şu An Açık Masalar</h3>
        {ozet.acikMasalar.length === 0 ? (
          <p className="text-center text-gray-400 text-sm py-4">Şu an açık masa yok</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {ozet.acikMasalar.map((masa) => (
              <div key={masa.masaNo} className="bg-orange-50 border border-orange-100 rounded-xl p-3 text-center">
                <p className="font-bold text-gray-800">Masa {masa.masaNo}</p>
                <p className="text-orange-500 font-bold text-lg">₺{masa.toplam}</p>
                <p className="text-xs text-gray-400 mt-1">{masa.siparisSayisi} sipariş</p>
              </div>
            ))}
          </div>
        )}
        {ozet.acikMasalar.length > 0 && (
          <div className="mt-3 pt-3 border-t border-gray-100 flex justify-between items-center">
            <span className="text-sm text-gray-600 font-medium">Toplam açık masa tutarı</span>
            <span className="font-bold text-orange-500">
              ₺{ozet.acikMasalar.reduce((a, m) => a + m.toplam, 0).toLocaleString('tr-TR')}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// ANA KASA EKRANİ
// ─────────────────────────────────────────────
function KasaEkrani({ kullanici }) {
  const [siparisler, setSiparisler] = useState([]);
  const [tamamlananlar, setTamamlananlar] = useState([]);
  const [cagrilar, setCagrilar] = useState([]);
  const [rapor, setRapor] = useState(null);
  const [aktifSekme, setAktifSekme] = useState('siparisler');
  const [kafeAdi, setKafeAdi] = useState('');
  const oncekiCagrilar = useRef([]);
  const oncekiSiparisler = useRef([]);

  const cafeId = kullanici.uid;

  const hepsiniGetir = async () => {
    try {
      const [s, t, c, r, k] = await Promise.all([
        fetch(`${BACKEND}/siparisler/${cafeId}`).then(r => r.json()),
        fetch(`${BACKEND}/siparisler/tamamlanan/${cafeId}`).then(r => r.json()),
        fetch(`${BACKEND}/siparisler/cagrilar/${cafeId}`).then(r => r.json()),
        fetch(`${BACKEND}/siparisler/rapor/${cafeId}`).then(r => r.json()),
        fetch(`${BACKEND}/menu/kafe-by-id/${cafeId}`).then(r => r.json()),
      ]);

      const yeniSiparisler = Array.isArray(s) ? s : [];
      yeniSiparisler.forEach(siparis => {
        if (!oncekiSiparisler.current.find(x => x.id === siparis.id)) sesCardir('siparis');
      });
      oncekiSiparisler.current = yeniSiparisler;

      const yeniCagrilar = Array.isArray(c) ? c : [];
      yeniCagrilar.forEach(cagri => {
        if (!oncekiCagrilar.current.find(x => x.id === cagri.id)) sesCardir(cagri.tip);
      });
      oncekiCagrilar.current = yeniCagrilar;

      setSiparisler(yeniSiparisler);
      setTamamlananlar(Array.isArray(t) ? t : []);
      setCagrilar(yeniCagrilar);
      setRapor(r);
      if (k && k.ad) setKafeAdi(k.ad);
    } catch (err) { console.error('Hata:', err); }
  };

  const siparisiBitir = async (siparisId) => {
    try {
      await fetch(`${BACKEND}/siparisler/${siparisId}/tamamla`, { method: 'PATCH' });
      hepsiniGetir();
    } catch { alert('Hata oluştu!'); }
  };

  const cagriiBitir = async (cagriId) => {
    try {
      await fetch(`${BACKEND}/siparisler/cagrilar/${cagriId}/tamamla`, { method: 'PATCH' });
      hepsiniGetir();
    } catch { alert('Hata oluştu!'); }
  };

  const masaKapat = async (masaNo) => {
    if (!window.confirm(`Masa ${masaNo} hesabı kapatılsın mı?`)) return;
    try {
      // 1) Masayı kapat — müşteri polling'i "kapali" durumunu görür ve localStorage'ı temizler
      await fetch(`${BACKEND}/siparisler/masa-kapat`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cafeId, masaNo }),
      });
      // 2) 10 saniye sonra masayı tekrar "acik" yap — yeni müşteri için hazır
      setTimeout(async () => {
        try {
          await fetch(`${BACKEND}/siparisler/masa-ac`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cafeId, masaNo }),
          });
        } catch {}
      }, 15000);
      hepsiniGetir();
    } catch { alert('Hata oluştu!'); }
  };

  useEffect(() => {
    hepsiniGetir();
    const interval = setInterval(hepsiniGetir, 5000);
    return () => clearInterval(interval);
  }, []);

  const masaBazliTamamlanan = tamamlananlar.reduce((acc, s) => {
    if (!acc[s.masaNo]) acc[s.masaNo] = { masaNo: s.masaNo, siparisler: [], toplam: 0 };
    const toplam = s.urunler.reduce((a, u) => a + u.fiyat * u.adet, 0);
    acc[s.masaNo].siparisler.push(s);
    acc[s.masaNo].toplam += toplam;
    return acc;
  }, {});

  const garsonCagrilari = cagrilar.filter(c => c.tip === 'garson');
  const aksiyonCagrilari = cagrilar.filter(c => c.tip === 'aksiyon');
  const hesapIstekleri = cagrilar.filter(c => c.tip === 'hesap');

  const sekmeler = [
    { key: 'siparisler', label: '📋 Siparişler' },
    { key: 'tamamlanan', label: '✅ Tamamlanan' },
    { key: 'raporlar', label: '📊 Raporlar' },
    { key: 'ozet', label: '💰 Özet' },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Üst Bar */}
      <div className="bg-white shadow-sm px-6 py-4 flex justify-between items-center sticky top-0 z-10">
        <div className="flex items-center gap-4">
          <h1 className="text-xl font-bold text-gray-800">🧾 Kasa Ekranı</h1>
          <a href="/mutfak" target="_blank" rel="noreferrer" className="bg-orange-500 text-white px-3 py-2 rounded-xl text-sm hover:bg-orange-600">👨‍🍳 Mutfak</a>
          {kafeAdi && <span className="text-gray-400 text-sm">— {kafeAdi}</span>}
        </div>
        <div className="flex gap-2 flex-wrap">
          {sekmeler.map(({ key, label }) => (
            <button key={key} onClick={() => setAktifSekme(key)}
              className={`px-4 py-2 rounded-xl text-sm font-medium ${aktifSekme === key ? 'bg-orange-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="p-6">
        {/* Bildirimler */}
        {cagrilar.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
            {hesapIstekleri.map(cagri => (
              <div key={cagri.id} className="bg-green-50 border-2 border-green-300 rounded-xl p-4 flex justify-between items-center">
                <div><p className="text-xs text-green-600 font-medium">💳 HESAP İSTEĞİ</p><p className="font-bold text-gray-800 text-lg">Masa {cagri.masaNo}</p></div>
                <button onClick={() => cagriiBitir(cagri.id)} className="bg-green-500 text-white px-4 py-2 rounded-xl font-semibold hover:bg-green-600 text-sm">Tamam</button>
              </div>
            ))}
            {garsonCagrilari.map(cagri => (
              <div key={cagri.id} className="bg-yellow-50 border-2 border-yellow-300 rounded-xl p-4 flex justify-between items-center">
                <div><p className="text-xs text-yellow-600 font-medium">🔔 GARSON ÇAĞRISI</p><p className="font-bold text-gray-800 text-lg">Masa {cagri.masaNo}</p></div>
                <button onClick={() => cagriiBitir(cagri.id)} className="bg-yellow-400 text-white px-4 py-2 rounded-xl font-semibold hover:bg-yellow-500 text-sm">Tamam</button>
              </div>
            ))}
            {aksiyonCagrilari.map(cagri => (
              <div key={cagri.id} className="bg-purple-50 border-2 border-purple-300 rounded-xl p-4 flex justify-between items-center">
                <div><p className="text-xs text-purple-600 font-medium">🎛️ AKSİYON TALEBİ</p><p className="font-bold text-gray-800">Masa {cagri.masaNo}: {cagri.mesaj}</p></div>
                <button onClick={() => cagriiBitir(cagri.id)} className="bg-purple-500 text-white px-4 py-2 rounded-xl font-semibold hover:bg-purple-600 text-sm">Tamam</button>
              </div>
            ))}
          </div>
        )}

        {/* SİPARİŞLER */}
        {aktifSekme === 'siparisler' && (
          siparisler.length === 0 ? (
            <div className="bg-white rounded-xl p-12 text-center text-gray-400 text-lg">✅ Bekleyen sipariş yok</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {siparisler.map(siparis => (
                <div key={siparis.id} className="bg-white rounded-xl shadow-sm p-5">
                  <div className="flex justify-between items-center mb-3">
                    <span className="font-bold text-xl text-gray-800">Masa {siparis.masaNo}</span>
                    <span className="bg-orange-100 text-orange-600 px-2 py-1 rounded-full text-xs font-medium">{siparis.durum}</span>
                  </div>
                  <div className="mb-3">
                    {siparis.urunler.map((urun, i) => (
                      <div key={i} className="flex justify-between text-gray-600 py-1.5 border-b border-gray-50 text-sm">
                        <span><span className="font-semibold text-gray-800">{urun.adet}x</span> {urun.ad}</span>
                        <span className="font-medium">₺{urun.fiyat * urun.adet}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex justify-between items-center mt-3 pt-2 border-t border-gray-100">
                    <span className="font-bold text-gray-800">₺{siparis.urunler.reduce((acc, u) => acc + u.fiyat * u.adet, 0)}</span>
                    <button onClick={() => siparisiBitir(siparis.id)} className="bg-green-500 text-white px-4 py-2 rounded-xl font-semibold hover:bg-green-600 text-sm">✅ Tamamla</button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}

        {/* TAMAMLANAN */}
        {aktifSekme === 'tamamlanan' && (
          Object.values(masaBazliTamamlanan).length === 0 ? (
            <div className="bg-white rounded-xl p-12 text-center text-gray-400 text-lg">Tamamlanan sipariş yok</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {Object.values(masaBazliTamamlanan).map(masa => (
                <div key={masa.masaNo} className="bg-white rounded-xl shadow-sm p-5">
                  <div className="flex justify-between items-center mb-3">
                    <span className="font-bold text-xl text-gray-800">Masa {masa.masaNo}</span>
                    <span className="font-bold text-green-600 text-lg">₺{masa.toplam}</span>
                  </div>
                  <div className="mb-3">
                    {masa.siparisler.map((siparis, i) => (
                      <div key={i}>
                        {siparis.urunler.map((urun, j) => (
                          <div key={j} className="flex justify-between text-gray-600 py-1.5 border-b border-gray-50 text-sm">
                            <span><span className="font-semibold text-gray-800">{urun.adet}x</span> {urun.ad}</span>
                            <span className="font-medium">₺{urun.fiyat * urun.adet}</span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                  <div className="flex gap-2 mt-3">
                    <button onClick={() => adisyonYazdir(masa, kafeAdi, false)} className="flex-1 bg-blue-500 text-white py-2 rounded-xl font-semibold hover:bg-blue-600 text-xs">📄 Yazıcı</button>
                    <button onClick={() => adisyonYazdir(masa, kafeAdi, true)} className="flex-1 bg-purple-500 text-white py-2 rounded-xl font-semibold hover:bg-purple-600 text-xs">🖨️ Termal</button>
                    <button onClick={() => masaKapat(masa.masaNo)} className="flex-1 bg-gray-800 text-white py-2 rounded-xl font-semibold hover:bg-gray-900 text-xs">💳 Kapat</button>
                  </div>
                </div>
              ))}
            </div>
          )
        )}

        {/* RAPORLAR */}
        {aktifSekme === 'raporlar' && <RaporlarSekmesi cafeId={cafeId} />}

        {/* GÜNLÜK ÖZET */}
        {aktifSekme === 'ozet' && <OzetSekmesi cafeId={cafeId} />}
      </div>
    </div>
  );
}

export default KasaEkrani;